module.exports = __webpack_public_path__ + "assets/profile-picture.245864a7153c80dffb2feddd34f9d365.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/profile-picture.jpg
 ** module id = 165
 ** module chunks = 0
 **/